import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Button,
    WhiteSpace,
    WingBlank,
    Toast,
    ActionSheet,
    Modal,
    Radio,
} from "antd-mobile";
import "./adminDetail.scss";
import axios from "../../../../service/axios";
import { connect } from "dva";
const Item = List.Item;
const RadioItem = Radio.RadioItem;
const loginAdminMsg =
    sessionStorage.getItem("loginMsg") &&
    JSON.parse(sessionStorage.getItem("loginMsg"));
@connect(({ app, enterpriseadmin }) => ({ app, enterpriseadmin }))
export class AdminDetails extends Component {
    state = {
        adminInfoDatas: {},
        adminUser: {},
        baseAvailInfo: {},
        loginAdminMsg: {},
        renewData: {},
        modal1: false,
        years: 3,
    };
    componentDidMount() {
        const { dispatch } = this.props;
        this.getAdminInfo();
    }
    getAdminInfo() {
        axios
            .get("/api/user/admin/find/login_name", {
                params: {
                    loginName: this.props.match.params.name,
                },
            })
            .then(res => {
                if (res && res.status == 200 && res.data) {
                    this.setState({
                        adminInfoDatas: res.data,
                        adminUser: res.data,
                        baseAvailInfo: res.data.baseAvailInfo,
                    });
                }
            });
    }
    
    // 年限设置
    showModal = key => (e) => {
        e.preventDefault(); // 修复 Android 上点击穿透
        axios
            .get("/api/user/admin/validYears/get", {
                params: {
                    targetId: this.props.match.params.id,
                },
            })
            .then(res => {
                if (res && res.status == 200 && res.data) {
                    this.setState({
                        years: res.data,
                    });
                }
            });
        this.setState({
            modal1: true,
        });
    }
    onClose = key => () => {
        this.setState({
            modal1: false,
        });
    }
    onChange = (years) => {
        this.setState({
            years,
        });
    }
    setYears = e => () => {
        this.onClose()();
        axios
            .get("/api/user/admin/validYears/set", {
                params: {
                    targetId: this.props.match.params.id,
                    years: this.state.years,
                },
            })
            .then(res => {
                if (res) {
                    if (res.status == 200) {
                        Toast.success(res.message, 1, () => {
                            this.props.history.goBack();
                        });
                    } else {
                        Toast.fail(res.message, 1);
                    }
                }
            });
    }

    
    render() {
        const { adminInfoDatas, adminUser } = this.state;
        const { match } = this.props;

        return (
            <div className="addAdmin">
                <div className="header-sticky header-navbar">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                    >
                        {match.params.name}
                        信息
                    </NavBar>
                </div>
                <div className="sub-container">
                    <form>
                        <List renderHeader={() => "基本信息"}>
                            <Item extra={`${adminUser.loginName}`}>
                                登录账号{" "}
                            </Item>
                            <Item extra={adminInfoDatas.createBy}>
                                上级账号{" "}
                            </Item>
                            <Item extra={adminInfoDatas.password}>密码 </Item>

                            <Item extra={`${adminUser.remarks || ""}`}>
                                备注{" "}
                            </Item>
                        </List>
                        <WhiteSpace size="lg" />
                        <WingBlank size="lg">
                            {
                                
                                <Button
                                    type="primary"
                                    onClick={() =>
                                        this.props.history.push(
                                            `/addadmin/${adminUser.loginName}/edit/${adminUser.id}`,
                                        )
                                    }
                                >
                                    修改
                                </Button>
                            }
                            <WhiteSpace />
                            <div>
                                <Button onClick={this.showModal()}>年限设置</Button>
                                <WhiteSpace />
                                {/* <Button onClick={() =>
                                    this.props.history.push(
                                        `/adminPermission/${adminUser.id}`,
                                    )
                                }>
                                    权限设置
                                </Button> */}
                                <WhiteSpace />
                            </div>
                        </WingBlank>
                        <WhiteSpace size="lg" />
                        <WhiteSpace size="lg" />
                        <Modal
                            visible={this.state.modal1}
                            transparent
                            maskClosable={false}
                            onClose={this.onClose()}
                            title="管理员年限设置"
                            footer={[{ text: '取消', onPress: () => this.onClose()() }, { text: '确定', onPress: () => this.setYears()() }]}
                            wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                        >
                            <div style={{ height: 100, overflow: 'scroll' }}>
                                <List>
                                    <RadioItem key={1} checked={this.state.years == 1} onChange={() => this.onChange(1)}>1年</RadioItem>
                                    <RadioItem key={2} checked={this.state.years == 3} onChange={() => this.onChange(3)}>3年</RadioItem>
                                </List>
                            </div>
                        </Modal>
                    </form>
                </div>
            </div>
        );
    }
}

export default AdminDetails;
